"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _theme = require("../../theme");

var _antd = require("antd");

var _excluded = ["showHandleButton"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Style = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-input-number {\n    height: 52px;\n    border-color: ", ";\n    width: 100%;\n    &:hover {\n        border-color: ", ";\n      }\n      &.ant-input-number-focused {\n        box-shadow: 0px 0px 0px 2px rgba(23, 54, 93, 0.2);\n        border-color: ", ";\n      }\n  }\n  .ant-input-number-handler:hover .ant-input-number-handler-up-inner, \n  .ant-input-number-handler:hover .ant-input-number-handler-down-inner {\n    color: ", ";\n  }\n  .ant-input-number-input-wrap,\n  .ant-input-number-input {\n    height: 100%;\n  }\n  .ant-input-number-input {\n    font-size: ", ";\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n  }\n  .hide-handle-button {\n    .ant-input-number-handler-wrap {\n      display : none;\n    }\n  }\n"])), _theme.theme.colors.grey, _theme.theme.colors.grey, _theme.theme.colors.blue_primay, _theme.theme.colors.blue_primay, _theme.theme.font_size.size_xl, _theme.theme.colors.black_secondary, _theme.theme.colors.grey_tertiary);

var InputNumberComponent = function InputNumberComponent(props) {
  var _props$showHandleButt = props.showHandleButton,
      showHandleButton = _props$showHandleButt === void 0 ? false : _props$showHandleButt,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Style, null), /*#__PURE__*/_react.default.createElement(_antd.InputNumber, _extends({
    className: showHandleButton ? "" : "hide-handle-button",
    showHandleButton: showHandleButton
  }, rest)));
};

var _default = InputNumberComponent;
exports.default = _default;